export default __webpack_public_path__ + "static/media/606_IMG2266.aeebd936.jpg";